import { jsx } from "react/jsx-runtime";
import { InitialComponent } from "@zillow/referral-pricing-ui-common";
import { useBlockEnvironment } from "@zillow/zrs-cms";
const PricingWebsiteDataBlock = () => {
  const {
    environment = "prod"
  } = useBlockEnvironment();
  const safeEnv = environment === "prod" ? "prod" : "dev";
  const endpoint = safeEnv === "prod" ? "https://www.zillow.com/graphql" : "https://zg-graph-dev.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql";
  return /* @__PURE__ */ jsx(InitialComponent, { url: endpoint });
};
const PricingWebsiteDataBlockExport = {
  Component: () => /* @__PURE__ */ jsx(PricingWebsiteDataBlock, {}),
  metadata: {
    category: "widgets",
    description: "A component to display Flex pricing tiers",
    icon: "chart-line",
    keywords: ["pricing", "tiers", "flex"],
    name: "carp-team/pricing-tier-component",
    title: "Flex Pricing Tiers"
  }
};
export {
  PricingWebsiteDataBlockExport as default
};
